@if (debugMode.isDebugMode()) {
    <div class="map-toolbar">
        <button
                matIconButton
                class="mat-icon-toggle-button"
                type="button"
                matTooltip="AI Debug Streams"
                matTooltipPosition="right"
                (click)="debugStream.openDebugDialog()">
            <mat-icon>bug_report</mat-icon>
        </button>
    </div>
}
<div class="map-toolbar">
  <button
    matIconButton
    class="mat-icon-toggle-button"
    [class.selected]="displayPanel"
    type="button"
    matTooltip="{{ !displayPanel ? 'AI Chat' : null }}"
    matTooltipPosition="right"
    (click)="togglePanelDisplay()">
    <mat-icon>smart_toy</mat-icon>
  </button>



  <div class="toolbar-panel-container" [hidden]="!displayPanel" #panelContainer>
    <div class="toolbar-panel-resize-handle" (mousedown)="onResizeStart($event)" aria-label="Resize panel"></div>
    <div class="ai-chat-toolbar-panel">

      <lib-chat-panel-hdr
        [title]="activeAgent()?.label ?? 'AI Assistant'"
        [agents]="agents"
        [selectedAgentId]="selectedAgentId() ?? ''"
        [showMinimize]="false"
        (agentChange)="onAgentChange($event)"
        (newChatRequested)="startNewChat()" />

      @if (agents.length > 0) {
        @for (key of [currentThreadId()]; track key) {
          <lib-chat-container
            class="ai-chat-container-fill"
            [agentId]="selectedAgentId() ?? agents[0].id"
            [idleConfig]="activeAgent()?.idleState"
            [threadId]="key"
            (runErrorChange)="panelRunError.set($event)" />
        }
      } @else {
        <div class="no-agent-msg">
          <mat-icon>smart_toy</mat-icon>
          <p>No agent configured</p>
        </div>
      }

    </div>
  </div>
</div>
